import { lazy } from 'react'

const PublishingPage = lazy(() => import('./desk/PublishingDesk'))

export { PublishingPage }
